<template>
  <section>
    <div class="intro-y box p-2 bg-white border border-theme-1 mt-2">
      <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
        <h2 class="font-medium text-base mr-auto">Crear Tarea</h2>
      </div>
      <form @submit.prevent="createTask" enctype="multipart/form-data">
        <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
          <div class="col-span-6 sm:col-span-6">
            <label>Nombre</label>
            <input
              type="text"
              class="input w-full border mt-2 flex-1"
              v-model="task_current.task"
              disabled
            />
          </div>
          <div class="col-span-6 sm:col-span-6">
            <label>Asignado a</label>
            <input
              type="text"
              class="input w-full border mt-2 flex-1"
              v-model="task_current.user.name"
              disabled
            />
          </div>
          <div class="col-span-3 sm:col-span-3">
            <label>Fecha</label>
            <input
              type="text"
              class="input w-full border mt-2 flex-1"
              v-model="task_current.date"
              disabled
            />
          </div>
          <div class="col-span-3 sm:col-span-3">
            <label>Cuenta</label>
            <input
              type="text"
              class="input w-full border mt-2 flex-1"
              v-model="task_current.account.name"
              disabled
            />
          </div>
          <div class="col-span-3 sm:col-span-3">
            <label>Proyecto</label>
            <select
              class="input w-full border mt-2 flex-1"
              v-model="form.project_id"
              required
            >
              <option value="">Seleccione...</option>
              <option
                v-for="project in filteredProjects"
                :value="project.id"
                :key="`create-task-project-${project.id}`"
              >
                {{ project.name }} - {{ project.account.prefix }}
              </option>
            </select>
          </div>
          <div class="col-span-3 sm:col-span-3">
            <label>Campaña</label>
            <select
              class="input w-full border mt-2 flex-1"
              v-model="form.campaign_id"
              required
            >
              <option value="">Seleccione...</option>
              <option
                v-for="campaign in filteredCampaigns"
                :value="campaign.id"
                :key="`create-task-campaign-${campaign.id}`"
              >
                {{ campaign.name }} - {{ campaign.project.name }}
              </option>
            </select>
          </div>
          <div class="col-span-12 sm:col-span-12 xxl:col-span-12">
            <label>Descripcion</label>
            <textarea
              class="input w-full border mt-2"
              rows="3"
              v-model="form.description"
            ></textarea>
          </div>
          <div class="col-span-12 sm:col-span-12">
            <label>Url Archivo (opcional)</label>
            <MultiSelect
              v-model="form.path"
              :options="options"
              :multiple="true"
              :taggable="true"
              @tag="addTag"
              class="mt-2"
            />
          </div>
          <div class="col-span-12 sm:col-span-12 xxl:col-span-12">
            <div
              class="rounded-md items-center px-5 py-4 mb-2 border border-theme-1 text-theme-1"
            >
              <b>Nota:</b> Recuerda compartir la carpeta o archivo a las
              personas involucradas.
            </div>
          </div>
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
          <button
            type="button"
            @click="$emit('closeModal')"
            class="button w-20 border text-gray-700 mr-1"
          >
            Cancelar
          </button>
          <button
            type="submit"
            class="button bg-theme-1 text-white"
            :class="createButtonLoading ? 'cursor-not-allowed opacity-50' : ''"
            :disabled="createButtonLoading"
          >
            {{ createButtonLoading ? 'Creando...' : 'Crear' }}
          </button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import MultiSelect from '@/components/assets/MultiSelect/MultiSelect'

export default {
  name: 'CreateTaskModal',
  props: ['task_current'],
  data() {
    return {
      form: {
        entity: 'task',
        path: [],
      },
      current_planning: {
        entity: 'planning',
      },
      options: [],
      createButtonLoading: false,
    }
  },
  async beforeMount() {
    try {
      await this.getList('project')
      await this.getList('campaign')
    } catch (error) {
      console.log('FAILURE!!', error)
    }
  },
  computed: {
    filteredCampaigns() {
      return this.campaigns.filter((campaign) => {
        return campaign.project_id == this.form.project_id
      })
    },
    filteredProjects() {
      return this.projects.filter((project) => {
        var account = project.account_id == this.task_current.account.id
        return account
      })
    },
    ...mapGetters({
      projects: 'getProjects',
      campaigns: 'getCampaigns',
    }),
  },
  methods: {
    ...mapActions(['getList', 'store', 'put']),
    createTask() {
      this.createButtonLoading = true
      this.form.user_id = this.task_current.user.id
      this.form.name = this.task_current.task
      this.form.date = this.task_current.date
      this.form.account_id = this.task_current.account.id
      this.form.hours = this.task_current.hours
      this.form.team_id = this.task_current.team_id
      //console.log(this.form);
      this.store([this.form])
        .then((item) => {
          this.current_planning.id = this.task_current.id
          this.current_planning.task_created = 'date'
          this.put(this.current_planning).then((item) => {
            this.$emit('closeModal')
            this.$emit('secondPlanningCreated')
          })
        })
        .catch((error) => {
          console.log('FAILURE!!', error)
        })
        .finally(() => {
          this.createButtonLoading = false
        })
    },
    addTag(newTag) {
      this.options.push(newTag)
      this.form.path.push(newTag)
    },
  },
  components: {
    MultiSelect,
  },
}
</script>



// WEBPACK FOOTER //
// CreateTaskModal.vue?0ba7fbca